import type { NonEmptyArray } from '@mntn-dev/utility-types'

export function last<T>(array: NonEmptyArray<T>): T
export function last<T>(array: T[] | undefined): T | undefined
export function last<T>(array: (T | null)[]): T | null
export function last<T>(array: (T | undefined)[]): T | undefined
export function last<T>(
  array: (T | null | undefined)[] | undefined
): T | null | undefined {
  const result = array && array.length > 0 ? array[array.length - 1] : undefined

  return result
}

export function assertLast<T>(array: (T | null | undefined)[] | undefined): T {
  const result = array ? array[array.length - 1] : undefined

  if (result === undefined || result === null) {
    throw new Error(
      'The last element of the array was unexpectedly undefined or null'
    )
  }

  return result
}
